import Icon, { BaseIconProps } from '../icons/react-components/Icon'
function SavedCartsIcon({ ...props }: BaseIconProps) {
  return (
    <Icon {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlSpace="preserve"
        viewBox="0 0 70 70"
        {...props}
      >
        <path fill="none" d="m25.91 22.96 3.27 15.83h19.23l4.78-15.42z" />
        <path d="M34.17 43.85c-3.27 0-5.82-.01-6.03-.02-2.33-.25-3.31-1.85-3.25-3.24.06-1.43 1.21-2.9 3.3-2.96 1.97-.05 9.04-.03 13.72-.01l5.73.01c1.41-4.43 3.37-10.75 4.02-13.2-3.84-.1-17.22-.01-26.35.09l-.83.01-1-4.46h-6.31c-.57 0-1.03-.46-1.03-1.03s.46-1.03 1.03-1.03h7.96l1 4.44c26.86-.29 27.1-.07 27.48.29.61.58.73.7-4.22 16.24l-.23.72-7.24-.01c-4.67-.02-11.72-.04-13.66.01-.87.02-1.28.51-1.29.98-.02.59.5 1.01 1.38 1.1.54.02 12.59.01 20.55-.01.57 0 1.03.46 1.03 1.03s-.46 1.03-1.03 1.03c-2.11.01-9.39.02-14.73.02" />
        <path d="m24.23 23.487 2.009-.46 3.508 15.344-2.008.459z" />
        <circle cx={31.03} cy={48.59} r={3.4} fill="none" />
        <path d="M31.03 51.99c-1.87 0-3.4-1.52-3.4-3.4 0-1.87 1.52-3.4 3.4-3.4s3.4 1.52 3.4 3.4c0 1.87-1.53 3.4-3.4 3.4m0-4.22c-.45 0-.82.37-.82.82s.37.82.82.82.82-.37.82-.82-.36-.82-.82-.82" />
        <circle cx={45.17} cy={48.59} r={3.4} fill="none" />
        <path d="M45.17 51.99c-1.87 0-3.4-1.52-3.4-3.4 0-1.87 1.52-3.4 3.4-3.4s3.4 1.52 3.4 3.4c-.01 1.87-1.53 3.4-3.4 3.4m0-4.22c-.45 0-.82.37-.82.82s.37.82.82.82.82-.37.82-.82-.37-.82-.82-.82" />
      </svg>
    </Icon>
  )
}
export default SavedCartsIcon
